export default __webpack_public_path__ + "static/media/04bg.52e65d57.png";